import React from 'react';
import SsembleSkeltonLoading from './components/SsembleSkeltonLoading';
import ShortsMaker from './components/ShortsMaker/ShortsMaker';
import LandingPage from './components/Landing/LandingPage';
import { BrowserRouter as Router, Route, Switch, Routes } from 'react-router-dom';
import uuid from 'react-uuid';
import './App.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AuthSection from './components/ShortsMaker/AuthSection';
import AuthSectionMultiSelect from './components/ShortsMaker/AuthSectionMultiSelect';
import AuthSectionMultiSelectDev from './components/ShortsMaker/AuthSectionMultiSelect-dev';
import AuthProcessing from './components/ShortsMaker/AuthProcessing';
import NotFound from './components/ShortsMaker/NotFound';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfServices from './components/TermsOfServices';
import SsembleBanner from './components/SsembleBanner/SsembleBanner';

// Landing-page switch. Set to true to serve the new Shorts Creator landing page at "/";
// set to false to instantly revert "/" to the classic page. The classic page is always
// reachable at /classic regardless of this flag.
const USE_NEW_LANDING = true;

// Shorts Creator is no longer running: show a big Ssemble banner above the homepage.
// Set to false to hide it.
const SHOW_SSEMBLE_BANNER = true;

function App() {
  const shortcodeSettings = {};

  const searchParams = new URLSearchParams(window.location.search);
  const video_url123 = searchParams.has('video_url') ? searchParams.get('video_url') : null;

  // Keep functional deep-links working: "/?requestId=..." resumes an existing job on the
  // classic tool, so the new landing page only takes over the bare "/" (no requestId).
  const hasRequestId = searchParams.has('requestId');
  const showNewLanding = USE_NEW_LANDING && !hasRequestId;

  return (

    <Routes>
    <Route path="/" element={<>{SHOW_SSEMBLE_BANNER && <SsembleBanner />}{showNewLanding ? <LandingPage shortcodeSettings={shortcodeSettings} /> : <ShortsMaker shortcodeSettings={shortcodeSettings} />}</>} />
    <Route path="/classic" element={<>{SHOW_SSEMBLE_BANNER && <SsembleBanner />}<ShortsMaker shortcodeSettings={shortcodeSettings} /></>} />
    <Route path="/upload" element={<AuthSection video_url123={video_url123} />} />
    <Route path="/upload_multiple" element={<AuthSectionMultiSelect video_url123={video_url123} />} />
    <Route path="/upload_multiple_dev" element={<AuthSectionMultiSelectDev video_url123={video_url123} />} />
    <Route path="/privacy" element={<PrivacyPolicy />} />
    <Route path="/terms" element={<TermsOfServices />} />
    <Route path="/calllback" element={<AuthProcessing />} />
    
    <Route path="*" element={<NotFound />} />
  </Routes>
    
  );
}

export default App;
